import React from "react";
import ML from "../assets/ML.jpg";
import TextReveal from "./TextReveal";
const Testimonials = () => {

  return (
    <>
      <div className="container">
        <div className="row pt-5 pb-5">
          <div className="col-lg-6 col-md-12  mb-3 mb-lg-0 ">
            <img
              // src="/Abstract-Profile-Photo-Instagram-Post.webp"
              src="/images/illustrations.jpeg"
              alt="empowering"
              className="w-100"
            />
          </div>
          <div className="col-lg-6 col-md-12  ">
            <h2 className="font-32">
              Hunarmand Punjab Strengthen the digital Economy through skills
              development & Youth Empowerment
            </h2>
            <p className="font-15 l-h-1">
              Hunarmand Punjab’s e-learning platform empowers low-income
              individuals by providing free access to digital skills and
              certifications, enabling employment and entrepreneurship. With
              600,000+ IT professionals and 20,000 graduates entering the field
              annually, Pakistan has potential, but still faces a major skills
              gap. Initiatives like e-Rozgar have created over 126,000 jobs and
              supported 1,300+ startups, showcasing the government's commitment
              to digital growth. E-learning reduces education costs, expands
              access, and directly addresses industry skill shortages. While
              Pakistan’s IT workforce is 500,000–700,000, the demand exceeds 2.5
              million. Boosting skills through online platforms strengthens
              local industries, reduces reliance on foreign expertise, and can
              help grow Pakistan’s $3.5B IT sector closer to regional giants
              like India and China.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
